import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './DeclineProposal.scss';
var cannotRejectProposal = function cannotRejectProposal(internalFeedbacks, rejectionText, userType) {
  return userType === 'clora_rep' && (internalFeedbacks.length === 0 || internalFeedbacks && internalFeedbacks.map(function (r) {
    return r.label;
  }).includes('Other') && rejectionText === '') || userType !== 'clora_rep' && rejectionText === '';
};
var DeclineProposal = /*#__PURE__*/function (_Component) {
  function DeclineProposal(props) {
    var _this;
    _classCallCheck(this, DeclineProposal);
    _this = _callSuper(this, DeclineProposal, [props]);
    _this.state = {
      reason: '',
      internalFeedbacks: ''
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSelectReason = _this.handleSelectReason.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(DeclineProposal, _Component);
  return _createClass(DeclineProposal, [{
    key: "handleInputChange",
    value: function handleInputChange(name, value) {
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "handleSelectReason",
    value: function handleSelectReason(option) {
      var internalFeedbacks = this.state.internalFeedbacks;
      if (internalFeedbacks && internalFeedbacks.find(function (i) {
        return i.value === option.value;
      })) {
        var existing = internalFeedbacks.find(function (i) {
          return i.value === option.value;
        });
        internalFeedbacks.splice(internalFeedbacks.indexOf(existing), 1);
        this.setState({
          internalFeedbacks: internalFeedbacks
        });
      } else if (internalFeedbacks) {
        this.setState({
          internalFeedbacks: [].concat(_toConsumableArray(internalFeedbacks), [option])
        });
      } else {
        this.setState({
          internalFeedbacks: [option]
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken,
        handleProposalAfterSubmit = _this$props.handleProposalAfterSubmit,
        showNewProposalUX = _this$props.showNewProposalUX;
      var internalFeedbacks = this.state.internalFeedbacks;
      var data = {
        reason: this.state.reason,
        internal_feedback_ids: internalFeedbacks && internalFeedbacks.map(function (r) {
          return r.value;
        })
      };
      return putRequest(formUrl, data, csrfToken).then(function (res) {
        if (showNewProposalUX) {
          handleProposalAfterSubmit(res.data);
        } else {
          window.location.reload();
        }
      })["catch"](function (err) {
        _this2.setState({
          errors: err
        });
      });
    }
  }, {
    key: "renderTextArea",
    value: function renderTextArea(placeholder) {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("textarea", {
        value: this.state.reason,
        className: "form-control",
        placeholder: placeholder,
        name: "reason",
        id: "reason",
        rows: "4",
        onChange: function onChange(val) {
          return _this3.handleInputChange('reason', val.target.value);
        }
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this4 = this;
      var _this$props2 = this.props,
        userType = _this$props2.userType,
        consultantName = _this$props2.consultantName,
        feedbackOptions = _this$props2.feedbackOptions;
      var internalFeedbacks = this.state.internalFeedbacks;
      if (userType === 'clora_rep') {
        return /*#__PURE__*/React.createElement("div", {
          className: "decline-proposal-modal style-guide"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-3"
        }, "Decline", consultantName, "'s proposal"), /*#__PURE__*/React.createElement("p", {
          className: "body-text-2 mb-3"
        }, "Why was \xA0", consultantName, "\xA0 not the right fit? \xA0", /*#__PURE__*/React.createElement("strong", null, "This will not be sent to the Consultant.")), /*#__PURE__*/React.createElement("div", {
          className: "mb-2"
        }, /*#__PURE__*/React.createElement(AsyncSelect, {
          className: "rejection-dropdown",
          classNamePrefix: "rejection-reason",
          loadOptions: function loadOptions() {
            return new Promise(function (resolve) {
              resolve(feedbackOptions);
            });
          },
          defaultOptions: true,
          value: internalFeedbacks,
          maxMenuHeight: 500,
          onChange: function onChange(val) {
            return _this4.handleInputChange('internalFeedbacks', val);
          },
          closeOnSelect: false,
          closeMenuOnSelect: false,
          isMulti: true,
          cacheOptions: true
        })), this.renderTextArea('Enter a rejection reason...'));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "decline-proposal-modal style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-8"
      }, "Decline", consultantName, "'s proposal"), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-3"
      }, "Why is \xA0", consultantName, "\xA0 not a good fit? Select all that didn't meet your expectations. \xA0", /*#__PURE__*/React.createElement("strong", null, "Only Clora will see your feedback.")), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 d-flex flex-wrap gap-3"
      }, (feedbackOptions || []).map(function (option) {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn-choice\"\n                  ".concat(internalFeedbacks && internalFeedbacks.find(function (f) {
            return f && f.value === option.value;
          }) ? 'selected' : ''),
          onClick: function onClick() {
            return _this4.handleSelectReason(option);
          }
        }, option.label);
      })), this.renderTextArea('Please provide more details here so we can find the best candidates.'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        triggerType = _this$props3.triggerType,
        userType = _this$props3.userType,
        buttonStyles = _this$props3.buttonStyles;
      var _this$state = this.state,
        internalFeedbacks = _this$state.internalFeedbacks,
        reason = _this$state.reason;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Decline",
        buttonStyles: buttonStyles,
        submitButtonText: userType === 'clora_rep' ? 'Yes, Decline' : 'Decline Proposal',
        submitButtonStyle: "danger",
        cancelButtonText: "No, Cancel",
        cancelButton: userType === 'clora_rep',
        handleSubmit: this.handleSubmit,
        submitDisabled: cannotRejectProposal(internalFeedbacks, reason, userType),
        triggerType: triggerType,
        idKey: "decline-proposal-modal",
        closeAfterSubmit: true
      }, this.renderContent());
    }
  }]);
}(Component);
DeclineProposal.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  triggerType: PropTypes.string,
  userType: PropTypes.string,
  consultantName: PropTypes.string.isRequired,
  feedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  buttonStyles: PropTypes.string,
  handleProposalAfterSubmit: PropTypes.func,
  showNewProposalUX: PropTypes.bool
};
DeclineProposal.defaultProps = {
  triggerType: 'button',
  userType: 'employer',
  feedbackOptions: [],
  buttonStyles: 'danger',
  handleProposalAfterSubmit: function handleProposalAfterSubmit() {},
  showNewProposalUX: false
};
export default DeclineProposal;